import api from "@/api/api-v2-config";

export async function getTicketListAxios() {
  return await api.get("tickets?pageNumber=1&pageSize=100000");
}

export async function getTicketIdAxios(id) {
  return await api.get("tickets/" + id);
}

export async function deleteTicketAxios(ticket) {
  return await api.delete("tickets/tickets", ticket);
}

export async function postTicketAxios(ticket) {
  return await api.post("tickets", ticket);
}

export async function putTicketAxios(id,ticket) {
  return await api.put("tickets/"+id, ticket);
}

export async function postCommentAxios(comment) {
  return await api.post("tickets/comment", comment);
}

export async function deleteCommentAxios(id) {
  return await api.delete("tickets/comment/" + id);
}
